module.exports = __webpack_public_path__ + "static/media/img-about-usp1-mobile@2x.6ea1de5a.jpg";